import { z } from 'zod';
import { uuidV7Schema } from '../uuid.js';
/**
 * Le rapport de contrôle — **ce que GHP vend** ([M11](../../../../docs/MODELE-DONNEES.md#m11)) :
 * généré côté serveur après validation, stocké comme `Document` de type `report`, et **jamais
 * régénéré**. Il fait office d'archive, ce qui dispense d'historiser propriétaire et habitant.
 */
export const REPORT_CONTENT_TYPE = 'application/pdf';
/**
 * Ce qu'un nom de fichier ne tolère pas : les séparateurs de chemin, les guillemets et
 * points-virgules qui couperaient l'en-tête `Content-Disposition`, les caractères de contrôle et
 * les blancs. Les lettres accentuées, elles, **restent** — l'en-tête les encode (RFC 5987), et les
 * aplatir ferait un fichier qui ne dit plus la même chose que l'écran.
 */
const UNSAFE_IN_FILE_NAME = /[\s/\\:*?"<>|;,\p{Cc}]+/gu;
/**
 * Le nom du fichier livré — **celui du prototype validé** : `Rapport_controle_<réf>.pdf`
 * (l'aperçu du rapport, back-office du 21/07).
 *
 * ⚠️ **Deux lecteurs qui ne peuvent pas s'importer l'un l'autre**, d'où le domaine : l'API, qui le
 * pose dans `Content-Disposition`, et le back-office, qui le propose à l'enregistrement. Deux
 * copies donneraient deux noms au même fichier — celui du navigateur et celui de l'archive.
 *
 * La Réf. GHP est libre et nullable ([M1](../../../../docs/MODELE-DONNEES.md#m1)) : sans elle, ou
 * blanche, c'est l'identifiant qui nomme le fichier. Un rapport sans nom ne se retrouverait pas
 * dans un dossier de téléchargements.
 */
export function reportFileName(inquiry) {
    const reference = inquiry.reference?.trim().replace(UNSAFE_IN_FILE_NAME, '-');
    return `Rapport_controle_${reference || inquiry.id}.pdf`;
}
/**
 * Le rapport tel que l'écran de validation le **voit** : qu'il existe, et depuis quand. Les octets
 * se demandent à part, comme ceux d'une pièce.
 *
 * `null` dans la lecture tant qu'il n'est pas généré — ce qui couvre trois cas que l'écran ne doit
 * pas confondre : une demande jamais validée n'en a pas encore (son statut le dit) ; une demande
 * validée attend sa génération, ou ne l'aura jamais sans relance (`reportStalled` les sépare).
 */
export const reportSummarySchema = z.object({
    documentId: uuidV7Schema,
    generatedAt: z.iso.datetime({ offset: true }),
});
//# sourceMappingURL=report.js.map